'use strict';
import $ from 'jquery';

export default class M108 {
  static init() {
    $('.module-m108').each((index, el) => {
      new M108($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.find('.module-m108-images').slick({
      arrows: false,
      speed: 4000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    });
  }
}
